import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = [
    { code: 'english', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
    { code: 'telugu', label: 'Telugu', nativeLabel: 'తెలుగు', flag: '🇮🇳' },
    { code: 'hindi', label: 'Hindi', nativeLabel: 'हिन्दी', flag: '🇮🇳' },
];

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('all'); // 'all' | 'english' | 'telugu' | 'hindi'

    return (
        <LanguageContext.Provider value={{ language, setLanguage, LANGUAGES }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}